<template>
    <div class="footer-container">
        <div class="ft-top-line"></div>
        <div class="ft-content flex row center vertical-cetner">
            <div class="flex-1 flex column md-container">
                <div class="flex center mg-spacing-sm">
                    <p class="ft-text fit-content" @click="about_link_special()">ABOUT US</p>
                </div>
                <div class="flex center mg-spacing-sm">
                    <p class="ft-text fit-content" style="color: #868e96; cursor: default;" v-on:click="$emit('app')">OUR APP</p>
                </div>
            </div>
            <div class="flex-1 flex column">
                <div class="mg-spacing">
                    <img @click="route('home')" :src="require('../assets/Desktop/Home_Landing/RE-Logo-Light.png')" alt="Royale Experience Logo">
                </div>
                <div>
                    <p class="ft-text fit-content"><span class="ft-link" @click="about_link_special()">ABOUT US</span> | <span class="ft-link" v-on:click="$emit('app')">OUR APP</span></p>
                </div>
                <div class="flex row space-evenly mg-spacing-md">
                    <div>
                        <a href="https://instagram.com/royalexperiencenow" target="_blank"><img :src="require('../assets/Desktop/Home_Landing/Insta.svg')" alt="Instagram"></a>
                    </div>
                    <div>
                        <a href="https://Facebook.com/royaltyexp" target="_blank"><img :src="require('../assets/Desktop/Home_Landing/fbook.svg')" alt="Facebook"></a>
                    </div>
                    <div>
                        <a href="https://twitter.com/royaltyexp" target="_blank"><img :src="require('../assets/Desktop/Home_Landing/twitter_icon.svg')" alt="Twitter"></a>
                    </div>
                </div>
            </div>
            <div class="flex-1 flex center md-container">
                <div class="ft-nav-list-ctn">
                    <ul class="fit-content">
                        <li class="ft-nav-itm ft-text" v-on:click="$emit('company')">COMPANY BREAKDOWN</li>
                        <li class="ft-nav-itm ft-text" v-on:click="$emit('offer')">THE OFFERING</li>
                        <li class="ft-nav-itm ft-text" v-on:click="$emit('app')">THE APPLICATION</li>
                        <li class="ft-nav-itm ft-text" @click="team_route()">OUR TEAM</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="ft-bottom-line">
            <span class="ft-bottom-span">&copy; ROYAL EXPERIENCE LLC  ALL RIGHTS RESERVED 2019</span>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                current_route: ''
            }
        },
        mounted() {
            this.current_route = this.$router.currentRoute
        },
        methods: {
            route: function(route) {
                if (route == 'about')
                    this.$router.push({'name': 'About'})
                if (route == 'home')
                    this.$router.push({'name': 'Home'})
            },
            team_route: function(e) {
                this.$router.push({'name': 'Team'})
            },
            about_link_special(){
                if(this.current_route.name === "About"){
                    window.scrollTo(0, 0);
                }
                else{
                    this.route('about')
                }
            }
            
        }
    }
</script>

<style scoped>
    @media (max-width: 880px) {
        .ft-text {
            color: #FFFFFF !important;
            font-family: Oswald !important;
            font-size: 14px !important;
            font-weight: bold !important;
            letter-spacing: 2px !important;
            line-height: 36px !important;
        }

        .ft-link {
            margin: 0 15px;
        }
    }

    .footer-container {
        height: 479px;
    }

    .ft-top-line {
        height: 10px;
        background-color: #9B111E;
    }

    .ft-content {
        height: 413px;
        background-color: #252525;
        justify-content: space-around;
        align-items: center;
    }

    .ft-bottom-line {
        display: table;
        height: 56px;
        text-align: center;
        width: 100%;
        background-color: #244F76;
    }

    .ft-bottom-span {
        display: table-cell;
        vertical-align: middle;
        color: #FFFFFF;
        font-family: Oswald;
        font-size: 12px;
        font-weight: 500;
        letter-spacing: 3.56px;
    }

    .ft-nav-itm {
        list-style: none;
        text-align: right;
        margin: 28px 0;
    }

    .ft-text {
        color: #FFFFFF;
        font-family: Oswald;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 1.44px;
        cursor: pointer;
    }

    .fit-content {
        width: fit-content;
        margin:auto;
        padding:0;
    }

    .mg-spacing {
        margin-top: 50px;
        margin-bottom: 50px;
        margin-left: auto;
        margin-right: auto;
    }

    .mg-spacing-sm {
        margin: 25px 0;
    }

    .mg-spacing-md {
        margin: 50px 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue